<script>
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';
	import WhyChooseUs from '$lib/PageSections/WhyChooseUs/WhyChooseUs.svelte';

	import ballsLargerTxt from './images/balls-larger.jpg';
	import headerImg from './images/masthead.svg';
	import personImg from './images/person.svg';
	import stackOfCoins from './images/stack-of-coins.jpeg';
</script>

<Section backgroundColor="blue" class="pt-0 pb-0">
	<Image src={headerImg} alt="March Madness Sale" />
</Section>

<Section>
	<h2>Score Big During Our March Madness Sale!</h2>
	<p>
		Don't let your windows play weak defense any longer! Indow window inserts
		are your defensive powerhouse against window drafts and noise.
	</p>
	<p>
		Sub in the insulation all-stars for your windows and score big with 10% off
		3-5 inserts, 15% off 6-9 inserts or a slam-dunk 20% off 10+ inserts.<a
			href="#**"
			class="no-underline"
			title="Discount valid for residential customers who start an order by 4/4/2025 and submit final payment by 4/30/2025. This offer may not be combined with any other offers or discounts."
			><sup class="text-indow-grey-dark">*</sup></a
		>
		Achieve peak performance in window comfort and efficiency without changing the
		look of your windows. Become a Comfort Champion and invest in decades of reduced
		energy costs with Indow window inserts.
	</p>
	<div class="grid gap-y-12 md:grid-cols-2">
		<Image
			src={personImg}
			alt="Connect with a Fit Specialist to craft a savings gameplan"
			class="max-w-[25rem]"
		/>
		<div class="grid gap-y-8">
			<div class="grid gap-2">
				<h3 class="!text-indow-blue md:text-left">
					STANDARD GRADE WINDOW INSERTS
				</h3>
				<p class="text-left">
					Decrease energy consumption by an average of 20%, reduce noise by up
					to 50%, and keep your home warmer in winter and cooler in summer.
				</p>
				<div class="flex justify-center">
					<ul class="w-auto">
						<li>Standard 3' x 4' window cost: <s>$372</s></li>
						<li>
							10+ sale price per window: $298<a
								href="#**"
								class="no-underline"
								title="Shipping and sales tax are not included. Shipping costs vary by size of order and location of delivery. Consult with a Fit Specialist for a shipping quote."
								><sup class="text-indow-grey-dark">**</sup></a
							>
						</li>
					</ul>
				</div>
			</div>

			<div class="grid gap-2">
				<h3 class="!text-indow-blue font-bold md:text-left">
					ACOUSTIC GRADE WINDOW INSERTS
				</h3>
				<p class="text-left">
					Enjoy all the benefits of Standard Grade window inserts
					<strong>PLUS</strong> up to 70% noise reduction.
				</p>
				<div class="flex justify-center">
					<ul class="w-auto">
						<li>Acoustic 3' x 4' window cost: <s>$480</s></li>
						<li>
							10+ sale price per window: $384<a
								href="#**"
								class="no-underline"
								title="Shipping and sales tax are not included. Shipping costs vary by size of order and location of delivery. Consult with a Fit Specialist for a shipping quote."
								><sup class="text-indow-grey-dark">**</sup></a
							>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
	<div class="my-4 grid gap-4">
		<p class="font-bold">
			Talk to a Fit Specialist today to get a free estimate.
		</p>
		<Button href="/indow-cost">SCORE BIG SAVINGS TODAY</Button>
	</div>
	<ul class="list-none text-sm">
		<li id="*">
			<p class="text-left">
				* Discount valid for residential customers who start an order by
				4/4/2025 and submit final payment by 4/30/2025. This offer may not be
				combined with any other offers or discounts.
			</p>
		</li>
		<li id="**">
			<p class="text-left">
				** Shipping and sales tax are not included. Shipping costs vary by size
				of order and location of delivery. Consult with a Fit Specialist for a
				shipping quote.
			</p>
		</li>
	</ul>
</Section>

<Section>
	<h2>The Best Offense Is A Good Defense</h2>
	<p>
		Imagine a basketball's worth of cold air escaping your single-pane windows
		<em>every hour</em> (double-panes aren't much better!). That's like throwing
		money out the window! Stop the energy drain this March Madness.
	</p>
	<Image
		src={ballsLargerTxt}
		alt="Defend against leaky windows with Indow inserts"
		class="px-2"
	/>
	<p>
		Level up your insulation game against leaky windows, maintaining your
		comfort and saving you an average of 20% on energy. That's a win for your
		wallet and the planet!
	</p>
	<Button href="/indow-cost">DRIBBLE INTO DEALS</Button>
</Section>

<Section
	backgroundColor="grey-light"
	imageColumn={stackOfCoins}
	imageColumnAlt="Stack up towering savings with IRA tax credits"
>
	<h2 class="text-indow-blue md:px-0">Save More With Tax Credits</h2>
	<p>
		You can save 30% on the cost of energy-saving Indow window inserts with tax
		credits from the Inflation Reduction Act. With these tax credits, you can
		lower your tax bill by up to $1,200 by purchasing approved energy efficient
		window inserts - that's over $100 in savings on a standard size Indow window
		insert!
	</p>
	<p>
		The best part? Indow's insulating window inserts qualify for this tax
		savings of up to $1,200/year on energy efficient home improvements.
	</p>

	<Button href="/window-insert-tax-savings">LEARN MORE</Button>
</Section>

<WhyChooseUs />
<GetAFreeEstimate />
<Reviews />
